module.exports = __webpack_public_path__ + "static/media/pt-flag.dd8ce33f.svg";